export default __webpack_public_path__ + "static/media/noun-escrow-account-3631234.03352b88.svg";